/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {WorkflowScript, WorkflowScriptFromJSON, WorkflowScriptToJSON,} from './WorkflowScript';

/**
 *
 * @export
 * @interface WorkflowScriptPageOf
 */
export interface WorkflowScriptPageOf {
    /**
     *
     * @type {number}
     * @memberof WorkflowScriptPageOf
     */
    totalRecords?: number;
    /**
     *
     * @type {Array<WorkflowScript>}
     * @memberof WorkflowScriptPageOf
     */
    data?: Array<WorkflowScript> | null;
}

export function WorkflowScriptPageOfFromJSON(json: any): WorkflowScriptPageOf {
    return WorkflowScriptPageOfFromJSONTyped(json, false);
}

export function WorkflowScriptPageOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowScriptPageOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(WorkflowScriptFromJSON)),
    };
}

export function WorkflowScriptPageOfToJSON(value?: WorkflowScriptPageOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'totalRecords': value.totalRecords,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(WorkflowScriptToJSON)),
    };
}

